import { SEPARATOR } from '../constants';

export * from './api-error-status';

export enum BaseLanguageType {
  EN = 'en',
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
}

export enum PaymentStatus {
  AUTHORIZED = 'Authorized',
  CANCELED = 'Canceled',
  CAPTURED = 'Captured',
  DELINED = 'Declined',
  PENDING = 'Pending',
  SYSTEM_ERROR = 'System Error',
  VOIDED = 'Voided',
  WEB3_ERROR = 'Web3 Error',
}

export enum BalanceType {
  DEPOSIT = 'Deposit',
  FREEZE = 'Freeze',
  MINT = 'Mint',
  RECEIVE = 'Receive',
  ROYALTY = 'Royalty',
  SERVICE_FEE = 'Service Fee',
  WITHDRAW = 'Withdraw',
}

export enum ThemeType {
  DARK = 'is_dark',
  LIGHT = 'light',
}

/**
 * Old design? Return the raw database launchpad status, it should have a lot, but frontned
 * currently only check 'PUBLISH'
 */
export enum LaunchpadRawStatus {
  PUBLISH = 'PUBLISH',
}

/**
 *  Backend will calculate all phase's start + end time and return the final status
 * - If all phases are upcoming, the status will be UPCOMING
 * - If one of the phase is live, the status will be LIVE
 * - If all phases are ended, the status will be ENDED
 */
export enum LaunchpadStatus {
  ENDED = 'ENDED',
  LIVE = 'LIVE',
  UPCOMING = 'UPCOMING',
}

export enum ContractType {
  COLLECTION_CONTRACT_FACTORY = 'COLLECTION_CONTRACT_FACTORY',
  COLLECTION_SIGN_CONTRACT_INFO = 'COLLECTION_SIGN_CONTRACT_INFO',
  MARKETPLACE_721 = 'MARKETPLACE_721',
  MARKETPLACE_TREASURY_WALLET_CONTRACT = 'MARKETPLACE_TREASURY_WALLET_CONTRACT',
}

export enum CollectionStatus {
  BLOCKED = 'BLOCKED',
  DRAFT = 'DRAFT',
  HIDDEN = 'HIDDEN',
  LISTING = 'LISTING',
  PENDING = 'PENDING',
}

export enum TokenType {
  ERC721 = 'ERC721',
  ERC1155 = 'ERC1155',
  SOULBOUND = 'SOULBOUND',
}

export enum PaymentEventType {
  BID_NFT = 'BID_NFT',
  BUY_NFT = 'BUY_NFT',
  DEPLOY_COLLECTION = 'DEPLOY_COLLECTION',
  MINT_NFT = 'MINT_NFT',
}

export enum NftEventType {
  // Display only
  CODE_LIST = 'CODE_LIST',
  // Force to plus one
  COUNT = 'COUNT',
  // Display only
  DISPLAY = 'DISPLAY',
  // Setter, allow to set any value
  POINTS = 'POINTS',
  // Call /event/nft/owner-qrcode/check will minus 1
  SYNC_QR_CODE_COUNT = 'SYNC_QR_CODE_COUNT',
}

export enum PaymentGatewayType {
  CREDIT_CARD = 'CREDIT_CARD',
  CRYPTOCURRENCY = 'CRYPTOCURRENCY',
  INTEGRATION_PAYMENT = 'INTEGRATION_PAYMENT',
}

export enum PaymentGatewayName {
  CHECKOUT = 'CHECKOUT',
  GKASH = 'GKASH',
  METAMASK = 'METAMASK',
  PAYDOLLAR = 'PAYDOLLAR',
  STRIPE = 'STRIPE',
}

export enum KycStatusEnum {
  APPROVE = 'APPROVE',
  PENDING = 'PENDING',
  REJECT = 'REJECT',
}

export enum AssetType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  MODEL = 'MODEL',
  PDF = 'PDF',
  VIDEO = 'VIDEO',
}

export enum OrderType {
  BID = 'BID',
  SALE = 'SALE',
}

export enum EventType {
  BID = 'BID',
  BID_ACCEPT = 'BID_ACCEPT',
  CANCEL = 'CANCEL',
  LIST = 'LIST',
  MINTED = 'MINTED',
  SALE = 'SALE',
  TRANSFER = 'TRANSFER',
}

export enum ListingType {
  BID = 'bid',
  BUY = 'buy',
}

export enum AttributeDisplayType {
  AUDIO = 'audio',
  COUNT_DOWN = 'count_down',
  DATE = 'date',
  DATE_TIME = 'date_time',
  HIDDEN = 'hidden',
  IMAGE = 'image',
  NUMBER = 'number',
  TEXT = 'text',
  URL = 'url',
  VIDEO = 'video',
}

export enum FlexibleMintSubmitStatus {
  APPROVE = 'APPROVE',
  CANCEL = 'CANCEL',
  DONE = 'DONE',
  FAILED = 'FAILED', // Web3 failed
  MINTING = 'MINTING', // Web3 processing
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING', // Backend processing
  REJECT = 'REJECT',
}

export enum FlexibleMintFormType {
  AI_MOTION = 'AI_MOTION',
  BASIC_FORM = 'FORM',
}

export enum AiMotionModel {
  FRONT_BACK_JUMP_DRIBBLE = 'FRONT_BACK_JUMP_DRIBBLE',
  GLUTE_BRIDGE = 'GLUTE_BRIDGE',
  HIGH_KNEE = 'HIGH_KNEE',
  JUMPING_JACK_DRIBBLE = 'JUMPING_JACK_DRIBBLE',
  LIFT_UP = 'LIFT_UP',
  LUNGE = 'LUNGE',
  PLANK = 'PLANK',
  PUSHUP = 'PUSHUP',
  SITUP = 'SITUP',
  SQUAT = 'SQUAT',
}

export enum AiMotionGoalType {
  WIN_BY_MAX_QUANTITY = 'WIN_BY_MAX_QUANTITY', // 比多
  WIN_BY_MAX_TIME = 'WIN_BY_MAX_TIME', // 比耐力
  WIN_BY_MIN_QUANTITY = 'WIN_BY_MIN_QUANTITY', // 比失誤少
  WIN_BY_MIN_TIME = 'WIN_BY_MIN_TIME', // 比快
}

export enum WalletProviderType {
  CUSTONOMY = 'CUSTONOMY', // External wallet provider
  NFTIV = 'NFTIV',
}

export enum QrCodePrefix {
  EXPORT_LOGIN_INFO = `EXPORT_LOGIN_INFO${SEPARATOR}`,
  EXPORT_VIRTUAL_ASSET = `EXPORT_VIRTUAL_ASSET${SEPARATOR}`,
  PROVE_HOLDERSHIP = `PROVE_HOLDERSHIP${SEPARATOR}`,
  PROVE_HOLDERSHIP_COMPRESSED = `PROVE_HOLDERSHIP_COMPRESSED${SEPARATOR}`,
  PROVE_OWNERSHIP = `PROVE_OWNERSHIP${SEPARATOR}`,
  VERIFY_HOLDERSHIP = `VERIFY_HOLDERSHIP${SEPARATOR}`,
}

export enum OtpActionType {
  BIND_EMAIL = 'bind_email',
  BIND_PHONE = 'bind_phone',
  CANCEL_BIND_EMAIL = 'cancel_bind_email',
  CANCEL_BIND_PHONE = 'cancel_bind_phone',
  CHANGE_2FA = 'change_2fa',
  CHANGE_EMAIL = 'change_email',
  CHANGE_PASSWORD = 'change_password',
  CHANGE_PHONE = 'change_phone',
  FORGOT_PASSWORD = 'forgot_password',
  LOGIN = 'login',
  LOGIN_OR_REGISTER = 'login_or_register',
  REGISTER = 'register',
}

export enum AuthorizationRecordStatus {
  AVAILABLE = 'AVAILABLE',
  EXPIRED = 'EXPIRED',
}

export const enum OauthType {
  IAMSMART = 'iamsmart',
  IAMSMART_PLUS = 'iamsmart_plus',
}

export enum ActivityDocStatus {
  SIGNED = 'SIGNED',
}

export enum ActivityDocSigningType {
  IAMSMART = 'iamsmart',
}
